import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 52 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.0365 9H18.2742L25.8287 2.5L32.3039 9H36.6208L38.7792 19.8333H44.1753L48.4921 39.3333H49.5714V40.4167H2.08594V39.3333H3.16515L7.48201 19.8333H12.8781L15.0365 9Z",
      stroke: "currentColor",
      "stroke-width": "3"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.5117 38.25V33.6943C21.5117 32.2537 22.2304 30.9079 23.4277 30.1067V30.1067C24.8806 29.1344 26.7765 29.1344 28.2295 30.1067V30.1067C29.4268 30.9079 30.1454 32.2537 30.1454 33.6943V38.25",
      stroke: "currentColor",
      "stroke-width": "3"
    }, null, -1)
  ]))]))
}
export default { render: render }